/* ---------- 9. register tabs (mobile — breakpoint CSS lives in styles/register-tabs.css → dist/theapp.css) ---------- */

import { $$ } from '../lib/dom';

export const REGISTER_MOBILE = '(max-width: 479px)'; // must match the media query in styles/register-tabs.css
const REGISTER_DEFAULT = 'player';

/** Bound at every width so a resize into mobile never lands on "all panes hidden"; ARIA only reflects tab mode. */
export const registerTabs = () =>
  $$('[data-register-tabs="wrap"]').forEach((wrap) => {
    const tabs = $$('[data-register-tab]', wrap);
    const panes = $$('[data-register-pane]', wrap);
    if (!tabs.length || !panes.length) return;
    const mq = window.matchMedia(REGISTER_MOBILE);
    let current: string | null = REGISTER_DEFAULT;

    const apply = () => {
      const aria = (node: Element, name: string, value: boolean) =>
        mq.matches ? node.setAttribute(name, String(value)) : node.removeAttribute(name);
      tabs.forEach((tab) => {
        const on = tab.getAttribute('data-register-tab') === current;
        tab.classList.toggle('is-active', on);
        aria(tab, 'aria-selected', on);
      });
      panes.forEach((pane) => {
        const on = pane.getAttribute('data-register-pane') === current;
        pane.classList.toggle('is-active', on);
        aria(pane, 'aria-hidden', !on);
      });
    };
    tabs.forEach((tab) =>
      tab.addEventListener('click', () => {
        current = tab.getAttribute('data-register-tab');
        apply();
      }),
    );
    mq.addEventListener('change', apply);
    apply();
  });
